export default {
  img: {
    offset: [100, 100],
    once: true,
  },
  productImageCard: {
    offset: [100, 100],
    once: true,
  },
};
